import firebase from "firebase/compat/app";
import {db} from "../firebase";
import {Collections} from "./collections";

export const incrementContentStatsViews = (contentId: string) => {
    if (!contentId) return Promise.reject();

    return db
        .collection(Collections.CONTENT_STATS)
        .doc(contentId)
        .set(
            {
                viewCount: firebase.firestore.FieldValue.increment(1),
                id: contentId,
            },
            {merge: true}
        );
};